import { getCurrentInstance } from 'vue';
export const useComboboxColumns = () => {
  const { proxy } = getCurrentInstance();
  const width = 110;

  const salaryColumns = [
    {
      dataField: 'ref_id',
      width: 125,
      filterable: true,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
  ];

  const customerColumns = [
    {
      title: 'Mã khách hàng',
      caption: 'Mã khách hàng',
      dataField: 'accounting_object_code',
      width: 125,
      filterable: true,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên khách hàng',
      caption: 'Tên khách hàng',
      dataField: 'accounting_object_name',
      width: 325,
      flexInQuickSearch: true,
      filterable: true,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
    {
      title: 'Mã số thuế',
      caption: 'Mã số thuế',
      dataField: 'company_tax_code',
      width: 125,
      filterable: true,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  const collectionAgencyColumns = [
    {
      title: 'Mã cơ quan thu',
      dataField: 'code',
      width: 140,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên cơ quan thu',
      dataField: 'name',
      width: 460,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  const projectColumns = [
    {
      title: 'Mã CTMT, dự án',
      dataField: 'project_code',
      width: 140,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên CTMT, dự án',
      dataField: 'project_name',
      width: 460,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const workItemColumns = [
    {
      title: 'Mã công trình',
      dataField: 'project_code',
      width: 140,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên công trình',
      dataField: 'project_name',
      width: 460,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const projectItemColumns = [
    {
      title: 'Mã dự án',
      dataField: 'project_code',
      width: 140,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên dự án',
      dataField: 'project_name',
      width: 460,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const bankColumns = [
    {
      title: 'Số tài khoản',
      dataField: 'bank_account',
      width: 180,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên ngân hàng',
      dataField: 'bank_name',
      width: 420,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const accountColumns = [
    {
      title: 'Mã đối tượng',
      dataField: 'accounting_object_code',
      width: 125,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên đối tượng',
      dataField: 'accounting_object_name',
      width: 350,
      flexInQuickSearch: true,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
    {
      title: 'Mã số thuế',
      dataField: 'company_tax_code',
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      width: 125,
    },
  ];

  const departmentColumns = [
    {
      title: 'Mã Phòng/Ban',
      dataField: 'department_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên Phòng/Ban',
      dataField: 'department_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  const budgetSourceColumns = [
    {
      title: 'Mã nguồn',
      dataField: 'budget_source_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên nguồn',
      dataField: 'budget_source_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const budgetChapterColumns = [
    {
      title: 'Mã chương',
      dataField: 'budget_chapter_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên chương',
      dataField: 'budget_chapter_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  const budgetKindItemColumns = [
    {
      title: 'Mã loại',
      dataField: 'budget_kind_item_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên loại',
      dataField: 'budget_kind_item_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const inventoryCategoryColumns = [
    {
      title: 'Mã loại VTHH',
      dataField: 'inventory_category_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên loại VTHH',
      dataField: 'inventory_category_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const costAccountColumns = [
    {
      title: 'Số tài khoản',
      dataField: 'account_number',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên tài khoản',
      dataField: 'account_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const stockColumns = [
    {
      title: 'Mã kho',
      dataField: 'stock_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên kho',
      dataField: 'stock_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const budgetSourcePropertyColumns = [
    {
      title: 'Mã tính chất',
      dataField: 'budget_source_property_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên tính chất',
      dataField: 'budget_source_property_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  const budgetItemColumns = [
    {
      title: 'Mã mục',
      dataField: 'budget_item_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên mục',
      dataField: 'budget_item_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const currencyColumns = [
    { title: 'Mã loại tiền', dataField: 'currency_code', width: 100 },
    { title: 'Tên loại tiền', dataField: 'currency_name', width: 500 },
  ];

  const fundColumns = [
    {
      title: 'Mã loại quỹ',
      dataField: 'fund_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên loại quỹ',
      dataField: 'fund_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const bankInfoCategoryColumns = [
    {
      title: 'Mã loại tài khoản',
      dataField: 'bank_info_category_code',
      width: 150,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên loại tài khoản',
      dataField: 'bank_info_category_name',
      width: 450,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const bankViewColumns = [
    {
      title: 'Mã ngân hàng',
      dataField: 'bank_code',
      width: 150,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên ngân hàng',
      dataField: 'bank_name',
      width: 450,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const bankInfoColumns = [
    {
      title: 'Số tài khoản',
      dataField: 'bank_account',
      width: 160,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên tài khoản NH, KB',
      dataField: 'bank_name',
      width: 440,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const statisticColumns = [
    {
      title: 'Mã thống kê',
      dataField: 'statistic_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên thống kê',
      dataField: 'statistic_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const accountingObjectColumns = [
    {
      title: 'Mã KH,NCC',
      dataField: 'accounting_object_code',
      width: 125,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên KH,NCC',
      dataField: 'accounting_object_name',
      width: 350,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      flexInQuickSearch: true
    },
    {
      title: 'Mã số thuế',
      dataField: 'company_tax_code',
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      width: 125,
    },
  ];
  const accountingObjectCustomColumns = [
    {
      title: 'Mã đơn vị',
      dataField: 'accounting_object_code',
      width: 125,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên đơn vị',
      dataField: 'accounting_object_name',
      width: 350,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      flexInQuickSearch: true
    },
    {
      title: 'Mã số thuế',
      dataField: 'company_tax_code',
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      width: 125,
    },
  ];

  const budgetGroupItemColumns = [
    {
      title: 'Mã nhóm mục',
      dataField: 'budget_group_item_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên nhóm mục',
      dataField: 'budget_group_item_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // thuộc nhóm
  const budgetBelongGroupItemColumns = [
    {
      title: 'Mã nhóm',
      dataField: 'budget_item_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên nhóm',
      dataField: 'budget_item_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // tiểu nhóm
  const budgetSubGroupItemColumns = [
    {
      title: 'Mã nhóm',
      dataField: 'budget_item_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên nhóm',
      dataField: 'budget_item_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // mục
  const budgetItemCustomColumns = [
    {
      title: 'Mã tiểu nhóm',
      dataField: 'budget_item_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên tiểu nhóm',
      dataField: 'budget_item_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // tiết tiểu mục
  const budgetSubSectionColumns = [
    {
      title: 'Mã tiểu mục',
      dataField: 'budget_item_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên tiểu mục',
      dataField: 'budget_item_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // nhiệm vụ

  const taskColumns = [
    {
      title: 'Mã nhiệm vụ',
      dataField: 'task_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên nhiệm vụ',
      dataField: 'task_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // phí, lệ phí

  const budgetFeesColumns = [
    {
      title: 'Mã phí, lệ phí',
      dataField: 'budget_fees_code',
      width: 140,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên phí, lệ phí',
      dataField: 'budget_fees_name',
      width: 460,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  // Loại khách hàng, nhà cung cấp
  const accountingObjectCategoryColumns = [
    {
      title: 'Mã loại KH, NCC',
      dataField: 'accounting_object_category_code',
      width: 160,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên loại KH, NCC',
      dataField: 'accounting_object_category_name',
      width: 440,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // Mẫu số hóa đơn
  const invoiceFormNumberColumns = [
    {
      title: 'Mẫu số',
      dataField: 'invoice_form_number_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên mẫu số',
      dataField: 'invoice_form_number_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  // chương trình mục tiêu, dự án
  const projectCustomColumns = [
    {
      title: 'Mã CTMT, dự án',
      dataField: 'project_code',
      width: 140,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên CTMT, dự án',
      dataField: 'project_name',
      width: 460,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // nhà cung cấp
  const accountingObjectSupplyColumns = [
    {
      title: 'Mã nhà cung cấp',
      dataField: 'accounting_object_code',
      width: 140,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên nhà cung cấp',
      dataField: 'accounting_object_name',
      width: 340,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      flexInQuickSearch: true
    },
    {
      title: 'Mã số thuế',
      dataField: 'company_tax_code',
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      width: 120,
    },
  ];

  const purchasePurposeColumns = [
    {
      title: 'Mã nhóm',
      dataField: 'purchase_purpose_code',
      width: 100,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên nhóm',
      dataField: 'purchase_purpose_name',
      width: 500,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const voucherTypeColumns = [
    {
      title: 'Mã loại chứng từ',
      dataField: 'voucher_type_code',
      width: 140,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Loại chứng từ',
      dataField: 'voucher_type_name',
      width: 460,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // Báo cáo
  const reportColumns = [
    {
      title: 'Mã báo cáo',
      dataField: 'report_id',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên báo cáo',
      dataField: 'report_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const stateBankColumns = [
    {
      title: 'Mã ngân hàng',
      dataField: 'state_bank_code',
      width: 150,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên ngân hàng',
      dataField: 'state_bank_name',
      width: 450,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  const commercialBankColumns = [
    {
      title: 'Mã ngân hàng',
      dataField: 'bank_code',
      width: 150,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên ngân hàng',
      dataField: 'bank_name',
      width: 450,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  const treasuryViewColumns = [
    {
      title: 'Mã kho bạc',
      dataField: 'state_bank_code',
      width: 150,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên kho bạc',
      dataField: 'state_bank_name',
      width: 450,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  // Loại Công cụ dụng cụ
  const toolTypeColumns = [
    {
      title: 'Mã loại CCDC',
      dataField: 'inventory_category_code',
      width: 150,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên loại CCDC',
      dataField: 'inventory_category_name',
      width: 450,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const salaryScaleColumns = [
    {
      title: 'Mã ngạch lương',
      dataField: 'salary_scale_code',
      width: 150,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên ngạch lương',
      dataField: 'salary_scale_name',
      width: 450,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const fundStructureColumns = [
    {
      title: 'Mã cơ cấu vốn',
      dataField: 'fund_structure_code',
      width: 150,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên cơ cấu vốn',
      dataField: 'fund_structure_name',
      width: 450,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];

  const budgetSubKindItemColumns = [
    {
      title: 'Mã khoản',
      dataField: 'budget_kind_item_code',
      width: 120,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên khoản',
      dataField: 'budget_kind_item_name',
      width: 480,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  const yearColumns = [
    {
      title: 'Năm',
      dataField: 'year',
      width: 150,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
  ];
  // Loại tài sản cố định
  const fixedAssetCategoryColumns = [
    {
      title: 'Mã loại TSCĐ',
      dataField: 'fixed_asset_category_code',
      width: 160,
      filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
    },
    {
      title: 'Tên loại TSCĐ',
      dataField: 'fixed_asset_category_name',
      width: 440,
      filterOperator: proxy.$ms.constant.FilterOperator.Contains,
    },
  ];
  //Tài sản cố định, TVDAT 09/12/2022
  const fixedAssetColumns = [
    {
      title: 'Mã tài sản',
      dataField: 'fixed_asset_code',
      width: 160,
    },
    {
      title: 'Tên tài sản',
      dataField: 'fixed_asset_name',
      width: 440,
    },
  ];

  const activityColumns = [
    {
      title: 'Mã hoạt động',
      dataField: 'activity_code',
      width: 160,
    },
    {
      title: 'Tên hoạt động',
      dataField: 'activity_name',
      width: 440,
    },
  ];

  const companyTaxColumns = [
    {
      title: 'Mã số thuế',
      dataField: 'taxCode',
      width: 160,
    },
    {
      title: 'Tên đơn vị',
      dataField: 'companyName',
      width: 440,
    },
  ]
  return {
    projectColumns,
    workItemColumns,
    projectItemColumns,
    projectCustomColumns,
    bankColumns,
    accountColumns,
    departmentColumns,
    budgetSourceColumns,
    budgetChapterColumns,
    budgetKindItemColumns,
    inventoryCategoryColumns,
    costAccountColumns,
    budgetSourcePropertyColumns,
    stockColumns,
    currencyColumns,
    fundColumns,
    bankInfoCategoryColumns,
    bankViewColumns,
    budgetSourcePropertyColumns,
    budgetItemColumns,
    bankInfoColumns,
    statisticColumns,
    accountingObjectColumns,
    accountingObjectCustomColumns,
    budgetGroupItemColumns,
    budgetSubGroupItemColumns,
    budgetItemCustomColumns,
    budgetSubSectionColumns,
    taskColumns,
    budgetFeesColumns,
    accountingObjectCategoryColumns,
    invoiceFormNumberColumns,
    accountingObjectSupplyColumns,
    voucherTypeColumns,
    reportColumns,
    budgetBelongGroupItemColumns,
    stateBankColumns,
    toolTypeColumns,
    purchasePurposeColumns,
    salaryScaleColumns,
    fundStructureColumns,
    budgetSubKindItemColumns,
    collectionAgencyColumns,
    customerColumns,
    salaryColumns,
    fixedAssetCategoryColumns,
    fixedAssetColumns,
    activityColumns,
    treasuryViewColumns,
    commercialBankColumns,
    companyTaxColumns
  };
};
